import createIcon from '../../createIcon';

/**
 * @component @name StackedBarChart
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCA5SDRWMjBIOFY5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTggNEg0VjhIOFY0WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE0IDdIMTBWMTFIMTRWN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAxMEgxNlYxNEgyMFYxMFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMCAxNUgxNlYyMEgyMFYxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNCAxMkgxMFYyMEgxNFYxMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StackedBarChart = createIcon('StackedBarChart', [
  ['path', { d: 'M8 9H4V20H8V9Z', key: '1l3a01' }],
  ['path', { d: 'M8 4H4V8H8V4Z', key: '1zbd1b' }],
  ['path', { d: 'M14 7H10V11H14V7Z', key: '9lx2tu' }],
  ['path', { d: 'M20 10H16V14H20V10Z', key: '1gb12k' }],
  ['path', { d: 'M20 15H16V20H20V15Z', key: '6zjl5i' }],
  ['path', { d: 'M14 12H10V20H14V12Z', key: 'njaekw' }],
]);

export default StackedBarChart;
